import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Modal } from "react-bootstrap";
import axios from "axios";
import { FaCheck, FaPlus, FaTimes } from "react-icons/fa";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import "../css/Admin_css/admin-customize.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const DEFAULT_PAPER_DETAILS = {
  paper_type: "",
  paper_code: 0,
  is_mark_system: "1",
  max_mark: "",
  max_grade: "",
  is_grade_system: "0",
};

const PAPER_TYPES = [
  { value: "Written", code: "1" },
  { value: "Oral", code: "2" },
  { value: "Theory", code: "3" },
  { value: "Practical", code: "4" },
  { value: "Project", code: "5" },
  { value: "Test", code: "6" },
  { value: "PT", code: "7" },
  { value: "NB", code: "8" },
  { value: "SE", code: "9" },
  { value: "SA", code: "10" },
  { value: "(W)", code: "11" },
  { value: "(O)", code: "12" },
  { value: "(P)", code: "13" },
  { value: "(T)", code: "14" },
  { value: "(NB)", code: "15" },
  { value: "(SE)", code: "16" },
  { value: "(SA)", code: "17" },
  { value: "(PT)", code: "18" },
  { value: "(TEST)", code: "19" },
  { value: "(TH)", code: "20" },
];

const DIALOG_STYLES = `
  .modal.show { display: block !important; opacity: 1 !important; }
  .modal.fade.show { opacity: 1 !important; }
  .mdl-multi-paper-dialog.modal-dialog {
    z-index: 1050 !important;
    position: relative;
    margin: 0.45rem auto 1rem;
    max-width: 760px;
  }
  .mdl-multi-paper-dialog.modal-dialog.modal-dialog-centered {
    min-height: calc(100% - 1rem);
  }
  .modal-backdrop { z-index: 1040 !important; }
  .modal-backdrop.show { opacity: 0.5 !important; }
  .mdl-multi-paper-dialog .modal-content {
    z-index: 1051 !important;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    border: 2px solid rgba(179, 229, 252, 0.55);
    box-shadow: 0 12px 28px rgba(2, 136, 209, 0.14);
    background: #fff;
  }
  .mdl-multi-paper-dialog .modal-header {
    border: none;
    padding: 12px 16px;
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 55%, #01579b 100%);
  }
  .mdl-multi-paper-dialog .modal-header .close {
    color: #fff;
    opacity: 0.92;
    text-shadow: none;
    font-size: 1.35rem;
    font-weight: 400;
    padding: 0.35rem 0.55rem;
  }
  .mdl-multi-paper-dialog .modal-body {
    padding: 12px 14px 10px;
    background: linear-gradient(180deg, #f7fcff 0%, #ffffff 42%);
  }
  .mdl-multi-paper-dialog .modal-footer {
    border-top: 1px solid #e1f5fe;
    padding: 10px 14px;
    background: #f0f9ff;
    display: flex;
    justify-content: flex-end;
    gap: 8px;
  }
  .mmp-title {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin: 0;
    color: #fff;
    width: 100%;
    padding-right: 18px;
  }
  .mmp-title__icon {
    width: 34px;
    height: 34px;
    border-radius: 10px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255,255,255,0.18);
    border: 1px solid rgba(255,255,255,0.35);
    font-size: 15px;
  }
  .mmp-title__main { font-size: 16px; font-weight: 800; line-height: 1.2; }
  .mmp-title__sub {
    margin-top: 2px;
    font-size: 11px;
    font-weight: 500;
    color: rgba(255,255,255,0.88);
  }
  .mmp-form {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 10px;
    padding: 10px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
    margin-bottom: 10px;
  }
  .mmp-field { display: flex; flex-direction: column; gap: 4px; }
  .mmp-field--full { grid-column: 1 / -1; }
  .mmp-field label {
    margin: 0;
    font-size: 10px;
    font-weight: 800;
    color: #0277bd;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .mmp-field input,
  .mmp-field select {
    min-height: 38px;
    border-radius: 8px;
    border: 2px solid rgba(179, 229, 252, 0.75);
    padding: 6px 10px;
    font-size: 13px;
    font-weight: 600;
    color: #37474f;
    background: #fff;
    outline: none;
  }
  .mmp-field input:focus,
  .mmp-field select:focus { border-color: #4fc3f7; }
  .mmp-marking { display: flex; flex-wrap: wrap; gap: 8px; }
  .mmp-marking__chip {
    display: inline-flex;
    align-items: center;
    min-height: 34px;
    padding: 4px 12px;
    border-radius: 999px;
    border: 2px solid rgba(179, 229, 252, 0.75);
    background: #fff;
    color: #455a64;
    font-size: 12px;
    font-weight: 700;
    cursor: pointer;
  }
  .mmp-marking__chip.is-active {
    border-color: #0288d1;
    background: #e1f5fe;
    color: #01579b;
  }
  .mmp-section-label {
    margin: 0 0 8px;
    font-size: 11px;
    font-weight: 800;
    color: #0277bd;
    text-transform: uppercase;
    letter-spacing: 0.03em;
  }
  .mmp-subject-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 8px;
    max-height: 260px;
    overflow-y: auto;
    padding: 2px;
  }
  .mmp-subject {
    display: flex;
    align-items: center;
    gap: 8px;
    text-align: left;
    padding: 10px 12px;
    border-radius: 10px;
    border: 2px solid rgba(179, 229, 252, 0.65);
    background: #fff;
    cursor: pointer;
    color: #455a64;
  }
  .mmp-subject.is-active {
    border-color: #0288d1;
    background: #e1f5fe;
    color: #01579b;
  }
  .mmp-subject__check {
    width: 20px;
    height: 20px;
    border-radius: 6px;
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 2px solid #b3e5fc;
    background: #fff;
    color: transparent;
    font-size: 10px;
  }
  .mmp-subject.is-active .mmp-subject__check {
    border-color: #0288d1;
    background: #0288d1;
    color: #fff;
  }
  .mmp-subject__name {
    display: block;
    font-size: 12px;
    font-weight: 800;
  }
  .mmp-subject__code {
    display: block;
    margin-top: 2px;
    font-size: 10px;
    font-weight: 600;
    opacity: 0.8;
  }
  .mmp-selected {
    margin-top: 10px;
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }
  .mmp-selected__pill {
    display: inline-flex;
    padding: 3px 9px;
    border-radius: 999px;
    background: #e8f5e9;
    border: 1px solid #a5d6a7;
    color: #2e7d32;
    font-size: 11px;
    font-weight: 700;
  }
  .mmp-empty {
    text-align: center;
    padding: 24px 12px;
    border-radius: 10px;
    border: 2px dashed rgba(179, 229, 252, 0.7);
    background: #f8fcff;
    color: #78909c;
    font-size: 13px;
    font-weight: 600;
  }
  .mmp-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    min-height: 36px;
    padding: 6px 14px;
    border-radius: 8px;
    font-size: 13px;
    font-weight: 800;
    border: 2px solid transparent;
    cursor: pointer;
  }
  .mmp-btn:disabled { opacity: 0.55; cursor: not-allowed; }
  .mmp-btn--ghost {
    background: #fff;
    border-color: #b3e5fc;
    color: #0277bd;
  }
  .mmp-btn--ghost:hover:not(:disabled) { background: #e1f5fe; }
  .mmp-btn--primary {
    background: linear-gradient(135deg, #03a9f4 0%, #0288d1 100%);
    border-color: #0288d1;
    color: #fff;
  }
  @media (max-width: 640px) {
    .mmp-form { grid-template-columns: 1fr; }
  }
`;

const MdlAddMultiplePapers = ({
  isOpen,
  onClose,
  onSuccess,
  exam_id,
  session_id,
  class_id,
  section_id,
  availableSubjects = [],
}) => {
  const [loading, setLoading] = useState(false);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [paperDetails, setPaperDetails] = useState(DEFAULT_PAPER_DETAILS);

  useEffect(() => {
    if (!isOpen) return undefined;
    const styleTag = document.createElement("style");
    styleTag.setAttribute("data-mdl-multi-paper", "1");
    styleTag.textContent = DIALOG_STYLES;
    document.head.appendChild(styleTag);
    return () => {
      if (styleTag.parentNode) styleTag.parentNode.removeChild(styleTag);
    };
  }, [isOpen]);

  useEffect(() => {
    if (isOpen) {
      setSelectedSubjects([]);
      setPaperDetails(DEFAULT_PAPER_DETAILS);
    }
  }, [isOpen]);

  const selectedSubjectIds = useMemo(
    () => new Set(selectedSubjects.map((s) => s.subject_id)),
    [selectedSubjects]
  );

  //Created By Cursor
  const handleSubjectToggle = useCallback((subject) => {
    setSelectedSubjects((prev) => {
      const isSelected = prev.some((s) => s.subject_id === subject.subject_id);
      if (isSelected) {
        return prev.filter((s) => s.subject_id !== subject.subject_id);
      }
      return [...prev, subject];
    });
  }, []);

  //Created By Cursor
  const handleInputChange = useCallback((field, value) => {
    setPaperDetails((prev) => ({ ...prev, [field]: value }));
  }, []);

  //Created By Cursor
  const setMarkingSystem = useCallback((system) => {
    setPaperDetails((prev) => ({
      ...prev,
      is_mark_system: system === "marks" ? "1" : "0",
      is_grade_system: system === "marks" ? "0" : "1",
    }));
  }, []);

  //Created By Cursor
  const handlePaperTypeChange = useCallback((e) => {
    const paperType = e.target.value || "";
    const selectedOption = e.target.options?.[e.target.selectedIndex];
    const paperCode = selectedOption?.dataset?.paper_code || "0";
    setPaperDetails((prev) => ({
      ...prev,
      paper_type: paperType,
      paper_code: paperCode,
    }));
  }, []);

  //Created By Cursor
  const validateForm = useCallback(() => {
    if (selectedSubjects.length === 0) {
      myToast.notify_warning("Please select at least one subject");
      return false;
    }
    if (!paperDetails.paper_code || paperDetails.paper_code === 0) {
      myToast.notify_error("Select Paper Type !");
      return false;
    }
    if (paperDetails.is_mark_system === "1" && !paperDetails.max_mark) {
      myToast.notify_error("Enter Max mark !");
      return false;
    }
    if (paperDetails.is_mark_system !== "1" && !paperDetails.max_grade) {
      myToast.notify_error("Enter Max grade !");
      return false;
    }
    return true;
  }, [selectedSubjects.length, paperDetails]);

  //Created By Cursor
  const handleSubmit = useCallback(async () => {
    if (!validateForm()) return;

    setLoading(true);
    try {
      const staffId = SessionManager.getStaffDetails()?.staff_id;
      const schoolCode = SessionManager.getSchoolCode();
      if (!staffId || !schoolCode) {
        myToast.notify_error("Session expired. Please login again.");
        setLoading(false);
        return;
      }

      const baseParams = {
        staff_id: staffId,
        exam_id,
        class_id,
        section_id,
        session_id,
        paper_type: paperDetails.paper_type,
        paper_code: paperDetails.paper_code,
        is_mark_system: paperDetails.is_mark_system,
        is_grade_system: paperDetails.is_grade_system,
        max_mark: paperDetails.max_mark || " ",
        max_grade: paperDetails.max_grade || " ",
        school_code: schoolCode,
      };

      const subjectIds = selectedSubjects.map((s) => s.subject_id).join(",");

      try {
        const response = await axios.get(
          `${API_BASE()}AddMultipleExamPaper.php`,
          {
            params: { ...baseParams, subject_ids: subjectIds },
          }
        );

        if (response.data?.api_status === "OK") {
          const { created_count, skipped_count } = response.data;
          if (created_count > 0) {
            myToast.notify_success(
              `Successfully created ${created_count} papers`
            );
            onSuccess();
            onClose();
          }
          if (skipped_count > 0) {
            myToast.notify_warning(
              `${skipped_count} papers were skipped (already exist)`
            );
          }
        } else if (response.data?.api_status === "WARNING") {
          myToast.notify_warning(response.data.api_remark);
          onSuccess();
          onClose();
        } else {
          myToast.notify_error(
            response.data?.api_remark || "Failed to create papers"
          );
        }
      } catch (apiError) {
        const results = await Promise.all(
          selectedSubjects.map((subject) =>
            axios.get(`${API_BASE()}AddNewExamPaper.php`, {
              params: {
                ...baseParams,
                subject_id: subject.subject_id,
                paper_name: subject.subject_name || subject.subject_id,
              },
            })
          )
        );
        const successCount = results.filter(
          (r) => r.data?.api_status === "OK"
        ).length;
        const errorCount = results.length - successCount;
        if (successCount > 0) {
          myToast.notify_success(`Successfully created ${successCount} papers`);
          onSuccess();
          onClose();
        }
        if (errorCount > 0) {
          myToast.notify_warning(`${errorCount} papers failed to create`);
        }
      }
    } catch (error) {
      myToast.notify_error(error.message || "Failed to create papers");
    } finally {
      setLoading(false);
    }
  }, [
    class_id,
    exam_id,
    onClose,
    onSuccess,
    paperDetails,
    section_id,
    selectedSubjects,
    session_id,
    validateForm,
  ]);

  if (!isOpen) return null;

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      animation={false}
      centered
      dialogClassName="mdl-multi-paper-dialog"
      aria-labelledby="mdl-multi-paper-title"
    >
      <Modal.Header closeButton={!loading}>
        <div className="mmp-title" id="mdl-multi-paper-title">
          <span className="mmp-title__icon" aria-hidden>
            <FaPlus />
          </span>
          <div>
            <div className="mmp-title__main">Create Multiple Papers</div>
            <div className="mmp-title__sub">
              Apply one paper setup across selected subjects
            </div>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body>
        <div className="mmp-form">
          <div className="mmp-field">
            <label htmlFor="mmp-paper-type">Paper Type</label>
            <select
              id="mmp-paper-type"
              value={paperDetails.paper_type}
              onChange={handlePaperTypeChange}
              disabled={loading}
            >
              <option value="">Select Paper</option>
              {PAPER_TYPES.map(({ value, code }) => (
                <option key={code} value={value} data-paper_code={code}>
                  {value}
                </option>
              ))}
            </select>
          </div>

          <div className="mmp-field">
            <label>Marking System</label>
            <div className="mmp-marking">
              <button
                type="button"
                className={`mmp-marking__chip${
                  paperDetails.is_mark_system === "1" ? " is-active" : ""
                }`}
                onClick={() => setMarkingSystem("marks")}
                disabled={loading}
              >
                Marks
              </button>
              <button
                type="button"
                className={`mmp-marking__chip${
                  paperDetails.is_grade_system === "1" ? " is-active" : ""
                }`}
                onClick={() => setMarkingSystem("grades")}
                disabled={loading}
              >
                Grades
              </button>
            </div>
          </div>

          <div className="mmp-field mmp-field--full">
            <label htmlFor="mmp-max-value">
              {paperDetails.is_mark_system === "1"
                ? "Maximum Marks"
                : "Maximum Grade"}
            </label>
            {paperDetails.is_mark_system === "1" ? (
              <input
                id="mmp-max-value"
                type="number"
                min="1"
                value={paperDetails.max_mark}
                onChange={(e) => handleInputChange("max_mark", e.target.value)}
                placeholder="e.g., 100"
                disabled={loading}
              />
            ) : (
              <input
                id="mmp-max-value"
                type="text"
                value={paperDetails.max_grade}
                onChange={(e) => handleInputChange("max_grade", e.target.value)}
                placeholder="e.g., A+, A, B+"
                disabled={loading}
              />
            )}
          </div>
        </div>

        <p className="mmp-section-label">Apply on Subjects</p>
        {availableSubjects.length === 0 ? (
          <div className="mmp-empty">No subjects available</div>
        ) : (
          <div className="mmp-subject-grid">
            {availableSubjects.map((subject) => {
              const active = selectedSubjectIds.has(subject.subject_id);
              return (
                <button
                  key={subject.subject_id}
                  type="button"
                  className={`mmp-subject${active ? " is-active" : ""}`}
                  onClick={() => handleSubjectToggle(subject)}
                  disabled={loading}
                >
                  <span className="mmp-subject__check" aria-hidden>
                    <FaCheck />
                  </span>
                  <span>
                    <span className="mmp-subject__name">
                      {subject.subject_name}
                    </span>
                    {subject.subject_code ? (
                      <span className="mmp-subject__code">
                        Code: {subject.subject_code}
                      </span>
                    ) : null}
                  </span>
                </button>
              );
            })}
          </div>
        )}

        {selectedSubjects.length > 0 ? (
          <div className="mmp-selected">
            {selectedSubjects.map((subject) => (
              <span key={subject.subject_id} className="mmp-selected__pill">
                {subject.subject_name}
              </span>
            ))}
          </div>
        ) : null}
      </Modal.Body>

      <Modal.Footer>
        <button
          type="button"
          className="mmp-btn mmp-btn--ghost"
          onClick={onClose}
          disabled={loading}
        >
          <FaTimes aria-hidden /> Cancel
        </button>
        <button
          type="button"
          className="mmp-btn mmp-btn--primary"
          onClick={handleSubmit}
          disabled={loading}
        >
          <FaPlus aria-hidden />
          {loading ? "Creating…" : "Create Papers"}
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default MdlAddMultiplePapers;
